import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { TabsComponent } from '@vg-constellation/angular-16/tabs';
import { Subscription } from 'rxjs';
import { AdobeLaunchService } from 'src/app/shared/services/adobe-launch.service';
import { ModalService } from 'src/app/shared/services/modal.service';
import { GradeMaterials } from 'src/app/shared/models/grade-materials.model';
import { GRADES_6_MATERIALS } from '../materials/6.materials';

@Component({
  selector: 'grades6',
  templateUrl: './grades6.component.html',
  styleUrls: ['./grades6.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class Grades6Component implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('jobsTabs') jobsTabs: TabsComponent;
  private langChangeSubscription!: Subscription;

  grades6Materials: GradeMaterials = GRADES_6_MATERIALS;

  @ViewChild('howWork') howWorkSection!: ElementRef;
  @ViewChild('curStand') curStandSection!: ElementRef;
  @ViewChild('finLit') finLitSection!: ElementRef;
  @ViewChild('proOut') proOutSection!: ElementRef;
  @ViewChild('econSys') econSysSection!: ElementRef;
  @ViewChild('prepMat') prepMatSection!: ElementRef;
  @ViewChild('rewards') rewardsSection!: ElementRef;
  @ViewChild('advMod') advModSection!: ElementRef;
  @ViewChild('firstDay') firstDaySection!: ElementRef;
  @ViewChild('actJobs') actJobsSection!: ElementRef;
  @ViewChild('actPayday') actPaydaySection!: ElementRef;
  @ViewChild('actFines') actFinesSection!: ElementRef;
  @ViewChild('actRent') actRentSection!: ElementRef;
  @ViewChild('actAuction') actAuctionSection!: ElementRef;
  @ViewChild('yearEnd') yearEndSection!: ElementRef;
  @ViewChild('classMaterials') classMaterialsSection!: ElementRef;
  
  constructor(
    public modalService: ModalService,
    private readonly adobeLaunchService: AdobeLaunchService,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.adobeLaunchService.trackPageView({
      pageTitle:'Grade 6'
    });
    
    this.langChangeSubscription = this.translateService.onLangChange.subscribe((_: LangChangeEvent) => {
      this.updateTabLabels();
    });
  }

  ngAfterViewInit(): void {
    this.updateTabLabels();
  }

  private updateTabLabels(): void {
    this.jobsTabs?.menuData?.items?.forEach(tab => {
      tab.labelText = this.translateService.instant('grades.table.header.' + (tab.tabPanelId || ''));
    });
  }

  ngOnDestroy(): void {
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe();
    }
  }

  onSidebarNavClick(elementName: string): void {
    const sectionMap: { [key: string]: ElementRef } = {
      howWork: this.howWorkSection,
      curStand: this.curStandSection,
      finLit: this.finLitSection,
      proOut: this.proOutSection,
      econSys: this.econSysSection,
      prepMat: this.prepMatSection,
      rewards: this.rewardsSection,
      advMod: this.advModSection,
      firstDay: this.firstDaySection,
      actJobs: this.actJobsSection,
      actPayday: this.actPaydaySection,
      actFines: this.actFinesSection,
      actRent: this.actRentSection,
      actAuction: this.actAuctionSection,
      yearEnd: this.yearEndSection,
      classMaterials: this.classMaterialsSection,
    };

    const targetSection = sectionMap[elementName];
    if (targetSection) {
      setTimeout(() => {
        targetSection.nativeElement.focus({ preventScroll: true });
      }, 0);
    }
  }
}
